import { render, staticRenderFns } from "./ContractsList.view.vue?vue&type=template&id=11bb20ac&"
import script from "./ContractsList.view.vue?vue&type=script&lang=js&"
export * from "./ContractsList.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11bb20ac')) {
      api.createRecord('11bb20ac', component.options)
    } else {
      api.reload('11bb20ac', component.options)
    }
    module.hot.accept("./ContractsList.view.vue?vue&type=template&id=11bb20ac&", function () {
      api.rerender('11bb20ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/contracts/ContractsList.view.vue"
export default component.exports